export default "__VITE_ASSET__DKet6$9p__"